// extracted by mini-css-extract-plugin
export var content = "_p7-1";
export var fullScreen = "_p7-0";